import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_entitlement_auto_top_up_event_filter_company_RowClass,
} from '../../../dbschema';

export class ClaimEntitlementAutoTopUpEventCompanyFilterContainerModel extends BaseContainerModel {
  bl_aat_entitlement_auto_top_up_event_filter_company: bl_aat_entitlement_auto_top_up_event_filter_company_RowClass =
    new bl_aat_entitlement_auto_top_up_event_filter_company_RowClass();
}
